import { FC } from "react";

import { useT } from "src/internationalization";

export type MarkerDetailsProps = {
  placeDetails?: google.maps.places.PlaceResult | null;
  companyName?: string | null;
  companyAddress?: string | null;
  onClose: () => void;
};

const MarkerDetails: FC<MarkerDetailsProps> = ({
  placeDetails,
  companyName,
  companyAddress,
  onClose,
}) => {
  const t = useT();
  if (!placeDetails && !companyName && !companyAddress) {
    return null;
  }

  return (
    <div className="absolute bottom-12 left-0 right-0 px-4">
      <div className="flex justify-between items-start bg-white p-4 rounded-lg">
        <div className="bg-[#f5f5f5] p-3 rounded-lg shadow-lg border border-gray-200 max-w-lg">
          <div className="flex items-center gap-2 mb-2 justify-between">
            <div>
              <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
              <p className="font-bold text-lg">{placeDetails?.name || companyName}</p>
            </div>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl">
              ×
            </button>
          </div>
          <p className="text-sm text-gray-600">
            {placeDetails?.formatted_address || companyAddress}
          </p>
          {placeDetails?.rating && (
            <div className="mt-2 flex items-center gap-1">
              <span className="text-sm font-medium">Rating:</span>
              <span className="text-sm text-yellow-500">{placeDetails.rating} ⭐</span>
            </div>
          )}
          {placeDetails?.user_ratings_total && (
            <div className="mt-1 text-xs text-gray-500">
              Based on {placeDetails.user_ratings_total} reviews
            </div>
          )}
          {placeDetails?.website && (
            <div className="mt-2">
              <a
                href={placeDetails.website.toString()}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:underline"
              >
                {t("widget.googleMap.website")}
              </a>
            </div>
          )}
          {placeDetails?.formatted_phone_number && (
            <div className="mt-1 text-sm text-gray-700">{placeDetails.formatted_phone_number}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarkerDetails;
